export class PaymentPdfDto {
    accountId = 0;
    startDate: Date | null = null;
    endDate: Date | null = null;
    dateSeleccionRange = "";
}